import React, { ChangeEvent } from 'react';
import { withRouter } from 'react-router';
import { TFundingData } from '../Funding/IFunding';
import queryString from 'query-string';
import IFeedSelect, { TFeedSelect, TValue } from './IFeedSelect';

import * as elements from '@appStyles/_elements.module.scss';

export class FeedSelect extends React.Component<IFeedSelect, TFeedSelect> {

  constructor(props: IFeedSelect) {
    super(props);

    const paramPitchId = this.props.blockByPitchId ? this.checkPitchIdParam() : '';

    this.state = {
      value: paramPitchId,
      pitchName: '' ,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps: IFeedSelect) {
    if (this.props.tmp !== nextProps.tmp) {
      this.setState({ value: '' });
    } else if (this.props.blockByPitchId && this.props.pitchId !== nextProps.pitchId) {
      this.setState({
        pitchName: this.getPitchName(nextProps.pitchId, nextProps),
        value: this.setValue(nextProps.pitchId),
      });
    }
  }

  selectChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const value = this.setValue(e.target.value);

    this.setState({ value });
    this.props.getSelectValue(value);
  }

  setValue = (value: TValue) => {
    if (!isNaN(Number(value)) && Number(value) !== 0) {
      return Number(value);
    }

    switch (value) {
      case 'update': return 'update';
      case 'general': return 'general';
      case '':
      case undefined:
        return undefined;
      default: return null;
    }
  }

  getPitchName(pitchId: TValue, props: IFeedSelect = this.props) {
    if (pitchId === null) {
      props.getSelectValue(null);
      return 'General';
    }

    const pitch = props.funding.find((elem) => {
      return elem.id === pitchId;
    });

    if (pitch) {
      props.getSelectValue(Number(pitch.id));
      return pitch.name;
    }

    props.getSelectValue(undefined);
    return '';
  }

  checkPitchIdParam = () => {
    if (this.props.location) {
      const param = queryString.parse(this.props.location.search).pitch_id;
      if (param) {
        const value = this.setValue(param);
        this.props.getSelectValue(value);

        return value;
      }
    }

    return '';
  }

  render() {
    const blocked = this.props.blockByPitchId && this.props.pitchId !== undefined;
    const disabled = blocked || !this.props.moreOptions && this.props.funding.length === 0;
    const pitchIdValue = this.props.pitchId === null ? 'general' : this.props.pitchId;

    return (
      <div className={elements.select}>
        <select
          disabled={disabled}
          onChange={this.selectChange}
          title={blocked ? 'Set filter to "All Topics" or "Company Update" to enable' : ''}
          value={this.state.value !== null ? this.state.value : ''}
        >
          {blocked ? (
            <option value={pitchIdValue} selected={true}>{this.state.pitchName}</option>
          ) : (
            <React.Fragment>
              {this.props.moreOptions && <option value="">All Topics</option>}
              {this.props.moreOptions && <option value="update">Company Update</option>}
              <option value="general">General</option>
              {this.props.funding.map((elem: TFundingData) => (
                <option key={elem.id} value={elem.id} >{elem.name}</option>
              ))}
            </React.Fragment>
          )}
        </select>
      </div>
    );
  }
}

export default withRouter(FeedSelect as any) as typeof FeedSelect;
